import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import TableSortLabel from '@material-ui/core/TableSortLabel';

import Paper from '@material-ui/core/Paper';
import { blue } from '@material-ui/core/colors';

import EmptyRows from '../../componets/EmptyRow.jsx';
import { path } from 'ramda';
import Avatar from '../../componets/Avatar.jsx';
import EnhancedTableToolbar from '../../componets/EnhancedTableToolbar.jsx'

import CONFIG from '../../config';

import DialogPanel from '../../componets/DialogPanel.jsx';
import DialogAction from '../../componets/DialogAction.jsx';
import SearchPanel from '../../componets/SearchPanel.jsx';

import { Family, Fonts, Colors, Icons, } from '../../themes';

import { InitWaitingTime, SetStateWithTime, SetStateWithObject } from '../../common/SetTime.js';
import { Roles } from '../../constant/JSON/Roles.js'
import WithDrawPanel from './WithDrawPanel.jsx'

import * as CustomerActions from '../../actions/Actions_CustomerManager.js';
import { NumberFormats } from '../../common/SetNumberFormat';
import Button from '../../constant/Button';

const { DoneIcon, CloseIcon, SendIcon } = Icons;
const fildeList = [
    { label: '', name: '', isOrder: false, },
    { label: 'NAME', name: 'name', isOrder: true, },
    { label: 'WALLET', name: 'wallet', isOrder: true, },
    { label: 'BANK ', name: '', isOrder: false, },
    { label: 'ACCOUNT NO.', name: '', isOrder: true, },
    { label: 'VERIFIED', name: '', isOrder: false, },
    { label: 'STATUS', name: '', isOrder: false, },
    { label: '', name: '', isOrder: false, }];

const _callStyle = { textAlign: 'center', paddingLeft: '5px', paddingRight: '10px', minWidth: 70 };
const _callName = { textAlign: 'left', paddingLeft: '20px', paddingRight: '5px', minWidth: 100 };
const _headCall = { paddingLeft: '25px', paddingRight: '5px', };
const _wording = { header: 'Supplier Manage' }

let CustomerList = [];
let waitingTime = true;
let WithdrawInfo;

class AccountingCustomerListPanel extends Component {

    state = { isLoading: false, isCreate: false, msgError: undefined, dialogType: undefined, orderBy: 'desc', sortFilde: undefined, searchActive: false }

    constructor(props) {
        super(props);

        // this.DisplaySupplierInfo = this.DisplaySupplierInfo.bind(this);
        // this.props.getAPICustomerList({ key: 'wallet', orderBy: 'desc', num_limit: 10 })
    }

    componentWillReceiveProps(nextProps) {

        const { CustomerManager } = nextProps;

        if (!!CustomerManager) {
            const { actions, data } = CustomerManager.CUSTOMER_REDUCER;

            switch (actions) {
                case CustomerActions.GET_CUSTOMER_SUCCESS:
                    {
                        CustomerList = data.result;
                        SetStateWithTime(this, waitingTime);
                    } break;
                case CustomerActions.GET_CUSTOMER_FAILURE:
                    {
                        SetStateWithTime(this, waitingTime);
                    } break;
            }
        }
    }

    render() {

        const { classes, CreatePanel, EditInfo, onClickHandle, isEmployee, Header, SearchType } = this.props;
        const { DisplaySupplierInfo } = this;

        const is_customer = ((CustomerList.length === 0)) ? false : (CustomerList.datas.length > 0);
        const { isLoading, isCreate, msgError, dialogType, searchActive, } = this.state;
        const _isEmployee = (false);

        //console.log('AccountingCustomerListPanel : ', CustomerList)

        return (
            <React.Fragment>
                {(isCreate) && <DialogAction Active={isCreate} OnClose={this.onClosePanel()} AcrionCom={this.TransferMoneyPanel()} />}
                {(isLoading) && <DialogPanel Active={isLoading} MSG={msgError} Type={dialogType} OnClose={() => { this.onCloseDialog() }} />}
                <Paper className={classes.root}>
                    <Table className={classes.table}>
                        <TableHead>
                            {/* <TableRow style={{ height: '100%' }}>
                                <TableCell colSpan={fildeList.length} style={{ padding: '0px' }} >
                                    <EnhancedTableToolbar numSelected={0} />
                                    <Button.Themes TitleText={Header || _wording.header}
                                        style={{ width: '100%' }} buttonStyle={{ marginTop: 0 }}
                                    //  onClick={() => this.setState({ searchActive: !searchActive })} 
                                    />
                                </TableCell>
                            </TableRow> */}
                            {(!_isEmployee) && ((searchActive) &&
                                (<TableRow>
                                    <TableCell colSpan={fildeList.length} style={{ padding: '0px' }} >
                                        <SearchPanel searchActive={searchActive} SearchType={SearchType} isAccounting={true} />
                                    </TableCell>
                                </TableRow>))}
                        </TableHead>
                        <TableHead>
                            <TableRow>
                                {fildeList.map((_filde, index) => {
                                    return (
                                        <TableCell key={index} style={(index === 1) ? _headCall : _callStyle}>
                                            {GetSortIcon(this.state.orderBy, _filde, this.handleRequestSort)}
                                        </TableCell>)
                                })}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {(is_customer) ? CustomerList.datas.map(_info => {

                                const { title, firstName, lastName, tel, bank, wallet, email, approved, isAcceptInformation, type, active, avatarLink, activeToken, memberLevelId, memberTypeId, registerDate, id, password } = _info;
                                let bankName = null;
                                let bankLogo = null;
                                const { BookBankList } = this.props;
                                let Language = path(['language'], BookBankList)
                                if (bank) {
                                    Array.isArray(BookBankList.datas) && BookBankList.datas.find((val) => (val.bankSettingId === bank.bankId) ? bankName = val[Language].name : null)
                                    Array.isArray(BookBankList.datas) && BookBankList.datas.find((val) => (val.bankSettingId === bank.bankId) ? bankLogo = val.logo.thumbnail : null)
                                }

                                return (
                                    <TableRow hover style={{ cursor: 'pointer' }} key={id} >
                                        <TableCell style={_callName}><Avatar URL={avatarLink.thumbnail || avatarLink} /></TableCell>
                                        <TableCell style={_callName} onClick={() => { DisplaySupplierInfo(_info) }} >{`${title || ''} ${firstName} ${lastName}`}</TableCell>
                                        <TableCell className={classes.text_info} style={{ ..._callStyle, textAlign: 'left' }} onClick={() => { DisplaySupplierInfo(_info) }} >{NumberFormats(wallet || 0)}</TableCell>
                                        <TableCell style={_callName} onClick={() => { DisplaySupplierInfo(_info) }} >{bank ? bankName : '-'}</TableCell>
                                        <TableCell className={classes.text_info} style={_callStyle} onClick={() => { DisplaySupplierInfo(_info) }} >{bank ? bank.accountNumber : '-'}</TableCell>
                                        <TableCell className={classes.text_info} style={_callStyle} onClick={() => { DisplaySupplierInfo(_info) }} >{approved ? 'Approved' : 'Pending'}</TableCell>
                                        <TableCell style={{ ..._callStyle, color: active ? Colors.success : Colors.error }} onClick={() => { DisplaySupplierInfo(_info) }} >{active ? 'Active' : 'Inactive'}</TableCell>
                                        <TableCell className={classes.text_info} style={_callStyle}>
                                            <Button.Icons icon={<SendIcon />} tooltip={'Send'} onClick={() => { this.TransferMoneyInfo(_info) }} />
                                        </TableCell>
                                    </TableRow>
                                );
                            }) : <EmptyRows fildeList={fildeList} />}
                        </TableBody>
                    </Table>
                    {(is_customer) && GetPagination(CustomerList, this.onNextPage, this.onChangeLimit)}
                </Paper>
            </React.Fragment >
        );
    }


    //===============================================================================================================================================================

    TransferMoneyPanel() {

        return (<WithDrawPanel BookBankList={this.props.BookBankList} WithdrawInfo={{ ...WithdrawInfo }} AssigneeType={Roles.Customer} OnClose={this.onClosePanel()} />)
    }

    TransferMoneyInfo(_info) {

        console.log('TransferMoneyInfo : ');
        WithdrawInfo = _info;
        this.setState({ isCreate: true })
    }

    DisplaySupplierInfo(_info) {

        console.log('DisplaySupplierInfo : ');
    }

    DisplaySupplierInfo(_info) {

        console.log('DisplaySupplierInfo : ');
    }

    getBackgroundImage(_isEmployee, logo) {
        return (_isEmployee) ?
            ({ position: 'relative', boxShadow: 'rgb(170, 169, 169) 0px 0px 1px 1.9px', backgroundRepeat: 'round', width: 50, height: 50, borderRadius: '50%', backgroundImage: `url(${CheckImageURL(logo)})`, backgroundRepeat: 'round', margin: 5 }) :
            ({ width: 70, height: 50, backgroundColor: 'gray', backgroundImage: `url(${CheckImageURL(logo)})`, backgroundRepeat: 'round', border: '1px solid #828181' });
    }

    handleRequestSort = (sortFilde) => {

        const { orderBy, field } = sortFilde;
        const _fildeName = field.name;
        //console.log('handleRequestSort : ', _fildeName, CustomerList)

        CustomerList.datas = (orderBy === 'desc')
            ? CustomerList.datas.sort((a, b) => (b[_fildeName] < a[_fildeName] ? -1 : 1))
            : CustomerList.datas.sort((a, b) => (a[_fildeName] < b[_fildeName] ? -1 : 1));

        this.setState({ orderBy: ((orderBy === 'asc') ? 'desc' : 'asc'), sortFilde: _fildeName });
    };

    onChangeLimit = (_limitRows) => {
        this.setState({ isLoading: true });
        this.props.getAPICustomerList({ key: 'wallet', orderBy: 'desc', page: 0, num_limit: _limitRows });
    }

    onNextPage = (_pageNumber, _limit) => {
        this.setState({ isLoading: true });
        this.props.getAPICustomerList({ key: 'wallet', orderBy: 'desc', page: _pageNumber, num_limit: _limit });
    }

    onCloseDialog = () => (this.setState({ isLoading: false, isCreate: false, msgError: undefined, dialogType: undefined }));

    onClosePanel = () => () => (this.setState({ isCreate: false, }));

    //===============================================================================================================================================================
}

const CheckImageURL = (_url) => (Boolean(_url) ? `${CONFIG.host}${_url}` : '');

function GetSortIcon(orderBy, field, handleRequestSort) {
    return (
        <TableSortLabel active={field.isOrder} direction={orderBy} onClick={() => { (field.isOrder) && handleRequestSort({ orderBy, field }) }}>
            {field.label}
        </TableSortLabel>)
}

function GetPagination(_ListCount, onNextPage, onChangeLimit) {

    const { total, page, limit, pageSize } = _ListCount;

    return (
        <TablePagination
            component="div"
            count={total || 0}
            rowsPerPage={limit || 10}
            page={page || 0}
            backIconButtonProps={{ 'aria-label': 'Previous Page', }}
            nextIconButtonProps={{ 'aria-label': 'Next Page', }}
            onChangePage={(event, page) => { onNextPage(page, limit) }}
            onChangeRowsPerPage={(event) => { onChangeLimit(event.target.value) }} />)
}

const styles = theme => (
    {
        root: {
            width: '100%',
            // marginTop: theme.spacing.unit * 3,
            overflowX: 'auto',
            // marginBottom: 10,
        },
        table: { minWidth: 1000, },
        button: { margin: theme.spacing.unit, },
        cssRoot: {
            color: theme.palette.getContrastText(blue[500]),
            backgroundColor: blue[500], '&:hover': { backgroundColor: blue[700], },
        },
    });

AccountingCustomerListPanel.propTypes = { classes: PropTypes.object.isRequired, };

function mapStateToProps(state, ownProps) { return { ...state }; }

function mapDispatchToProps(dispatch) {
    return {
        getAPICustomerList: (_keyword, _filter) => {
            InitWaitingTime();
            dispatch(CustomerActions.getCustomerList(_keyword, _filter));
        },
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(AccountingCustomerListPanel));
